import React from 'react';
import styled from 'styled-components';
import { mediaQuery, typography } from '../../theme';
import dayjs from '../../utils/dayjs';
import { storage } from '../../utils/storage';
import { Primary } from '../button';
import { useRouter } from 'next/navigation';

export const ErrorPage: React.FC = () => {
  const router = useRouter();

  return (
    <>
      <TextContent>
        <StyledHeader>Tapahtui yllättävä virhe</StyledHeader>
        <StyledParagraph>{dayjs().toString()}</StyledParagraph>
        <ButtonWideInMobile onClick={() => router.push('/')}>Palaa etusivulle</ButtonWideInMobile>
        <StyledParagraph>Mikäli ongelma toistuu, paina allaolevaa nappia.</StyledParagraph>
        <ButtonWideInMobile
          onClick={() => {
            storage.clear();
            router.push('/');
          }}
        >
          Käynnistä pizzakauppa uudestaan
        </ButtonWideInMobile>
      </TextContent>
      <StyledNotFoundImage />
    </>
  );
};

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12em 1em 0 1em;
  width: calc(100% - 2em);

  @media ${mediaQuery.medium} {
    padding-top: 8rem;
  }

  @media ${mediaQuery.small} {
    padding-top: 6rem;
  }
`;

const StyledHeader = styled.h1`
  ${typography.headingLargeStyle}
  font-size: 3.125rem;
  letter-spacing: 0;
  line-height: 100%;
  font-weight: 1000;
  margin-bottom: 20px;
  text-align: center;
`;

const ButtonWideInMobile = styled(Primary)`
  width: auto;
  margin-bottom: 1.25em;

  @media ${mediaQuery.small} {
    width: 100%;
  }
`;

export const StyledParagraph = styled.p`
  ${typography.textStyle}
  text-align: center;
  margin-bottom: 1.25em;
`;

const StyledNotFoundImage = styled.div`
  background-position-x: center;
  background-position-y: top;
  background-size: cover;
  width: 100%;
  max-width: 1800px;
  height: 550px;
  margin: 0 auto;

  @media ${mediaQuery.medium} {
    margin-top: 3.75em;
    height: 400px;
  }

  @media ${mediaQuery.small} {
    height: 250px;
  }
`;
